var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"id":"main-content","fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('main',{staticClass:"container pa-0 px-sm-3 pb-sm-3 pt-sm-9",attrs:{"role":"main"}},[_c('router-view')],1)])],1)],1),_c('Footer'),_c('analytics')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }